import React, { useState, useEffect } from 'react'
import { useNavigate } from 'react-router-dom';
import { Box, Button, FormControl, Select, InputLabel, MenuItem, Divider } from '@mui/material';
import { getHeadquarterGoalsMonths, getYears } from '../../utils/constCodeUtils';
import { useDispatch, useSelector } from 'react-redux';
import { treeDeparts } from '../../modules/deptModule/departs';
import _ from 'lodash';
import HeadquartersGoalSetting from '../../components/salesgoalmng/HeadquartersGoalSetting';

const HeadquarterSalesGoalEditContainer = () => {
  const dispatch = useDispatch();
  let navigate = useNavigate();
  const handleGoBack = () => {
    navigate('/salesgoalmng');
  };

  const [years, setYears] = useState(null);
  const [selectedYear, setSelectedYear] = useState(new Date().getFullYear());
  const [goalsData, setGoalsData] = useState([]);

  const { departs, error, loading } = useSelector(
    ({ departModule, loading }) => ({
      departs: departModule.departs.departs,
      error: departModule.departs.error,
      loading: loading['depart/TREE_DEPART'],
    }),
  );

  useEffect(() => {
    if (!departs) {
      dispatch(treeDeparts());
    }

  }, [departs, dispatch]);

  useEffect(() => {
    if (departs?.children) {
      const filteredDeaprt = _.filter(departs?.children, (depart) => depart.Level === "1");
      const data = getHeadquarterGoalsMonths(filteredDeaprt);
      console.log(data);
      setGoalsData(data);
    }

  }, [departs])


  const handleChangeYear = (event) => {
    setSelectedYear(event.target.value)
  }



  useEffect(() => {
    const arrYears = getYears(3, 1);
    setYears(arrYears);


  }, [])

  


  return (
    <Box sx={{ display: 'flex', flexDirection: 'column' }}>
      <Box sx={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center' }}>
        <Box sx={{ display: 'flex', flexDirection: 'row', justifyContent: 'flex-start', alignItems: 'center' }}>
          <Box sx={{ mr: 1, minWidth: 120 }}>
            <FormControl variant="standard" fullWidth>
              <InputLabel id="selected-year-label">기준년도</InputLabel>
              <Select
                labelId="selected-year-label"
                id="selected-year"
                value={selectedYear}
                label="년도"
                onChange={handleChangeYear}
              >
                {years && years.map((item, index) => (
                  <MenuItem key={index} value={item}>{item}</MenuItem>
                ))}

              </Select>
            </FormControl>
          </Box>

        </Box>
        <Box>
          <Button variant="outlined" onClick={handleGoBack}>목표 및 실적관리</Button>
        </Box>
      </Box>
      <Divider sx={{ my: 1 }} />
      <Box>
          <HeadquartersGoalSetting rows={goalsData}/>
      </Box>
    </Box>
  )
}

export default HeadquarterSalesGoalEditContainer